import { render } from "./GiftPackRewardResult.vue?vue&type=template&id=61a672b9&scoped=true"
import script from "./GiftPackRewardResult.vue?vue&type=script&lang=js"
export * from "./GiftPackRewardResult.vue?vue&type=script&lang=js"

import "./GiftPackRewardResult.vue?vue&type=style&index=0&id=61a672b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a672b9"]])

export default __exports__